import Vue, {VueConstructor} from 'vue'

// @ts-ignore
import Datepicker from '@/common/libs/vuejs-datepicker/components/Datepicker'

// @ts-ignore
import ptBR from '@/common/libs/vuejs-datepicker/locale/translations/pt-BR'

Vue.component('datepicker', Datepicker)

Vue.use((vue: VueConstructor) => {
    vue.prototype.$i8n = {
        datepicker: ptBR
    }
})
